import { CallerRef } from './use-caller-id';

// Hand-off channel between the app-wide banner host (Book tap, any page) and
// the calendar's CallerIdOverlay. A plain module value instead of router
// location state: HashRouter (Capacitor native) doesn't reliably carry state,
// and this survives the /calendar remount either way.
let pendingBooking: CallerRef | null = null;

export const setPendingCallerBooking = (caller: CallerRef): void => {
  pendingBooking = caller;
};

// read-and-clear so back-navigation/re-renders can't reopen the form
export const consumePendingCallerBooking = (): CallerRef | null => {
  const caller = pendingBooking;
  pendingBooking = null;
  return caller;
};
